var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from "./component";
var Progress = /** @class */ (function (_super) {
    __extends(Progress, _super);
    function Progress(args) {
        var _a;
        var _this = _super.call(this, args) || this;
        _this.render = function () {
            //progress is purely an element no instantiation needed, no options, no events, no methods
            _this.setElement();
            return _this.element;
            // if(this.container){
            //     if(typeof this.container === "string"){
            //         document.querySelector(this.container)?.appendChild(this.element);
            //     }else{
            //         this.container.appendChild(this.element);
            //     }
            // }else{
            //     console.log('no container')
            //     return this.element;
            // }
        };
        _this.name = "progress";
        _this.percentage = (_a = args === null || args === void 0 ? void 0 : args.percentage) !== null && _a !== void 0 ? _a : 0;
        _this.container = args === null || args === void 0 ? void 0 : args.container;
        _this.composer = args === null || args === void 0 ? void 0 : args.composer;
        return _this;
    }
    return Progress;
}(Component));
export { Progress };
